import React from 'react';
import styles from './Toggle.module.scss';

function Toggle(props: ToggleProps) {
  const {
    options, onClick, selected, className,
  } = props;
  return (
       <div className={`${styles.toggleContainer} ${className}`}>
           {
               options.map((option, index) => <div
                className={`${styles.toggleOption} ${selected === index ? styles.selected : ''}`}
                key={`toggle-item-${option.label}`} onClick={() => onClick(index)}>{option.label}</div>)
           }
       </div>
  );
}

export default Toggle;
